import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { archiveFields } from 'api/field'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export default function ArchiveField(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { selectedFieldIds, callback } = props

  const closePopup = () => dispatch(closeModal())

  const archive = () => {
    //@ts-expect-error
    dispatch(archiveFields(selectedFieldIds, callback))
    dispatch(closeModal())
  }

  return (
    <ModalContainer>
      <div>
        {t('archive_item_warning', {
          item: selectedFieldIds.length > 1 ? t('fields') : t('field'),
        })}
      </div>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={archive}>
          {t('archive')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
